const SoundIcon = ({ ..._props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.5 7.5C16.5 7.5 18 9 18 11.5C18 14 16.5 15.5 16.5 15.5M19.5 4.5C19.5 4.5 22 7 22 11.5C22 16 19.5 18.5 19.5 18.5M2 10V14C2 14.5523 2.44772 15 3 15H5.69722C5.89465 15 6.08766 15.0584 6.25192 15.1679L10.4453 17.9635C11.1099 18.4066 12 17.9302 12 17.1315V6.86852C12 6.06982 11.1099 5.59343 10.4453 6.03647L6.25192 8.83205C6.08766 8.94156 5.89465 9 5.69722 9H3C2.44772 9 2 9.44772 2 10Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SoundIcon;
